import WalletConnectProvider from '@walletconnect/web3-provider';
import { networks } from '../constants/networks';
import { stateEventObserver } from './EventObserver';
import EventTypes from '../constants/eventTypes';
import { WALLET_TYPES } from '../constants/wallet';

let provider: WalletConnectProvider | undefined;

// https://docs.walletconnect.com/1.0/quick-start/dapps/web3-provider#events-eip-1193

export const removeWalletConnectListeners = () => {
  if (provider?.removeAllListeners) {
    provider.removeAllListeners();
  }
};

const subscribeWalletConnectEvents = (networkId: number, rpcUrl: string) => {
  provider.on('accountsChanged', (accounts: string[]) => {
    removeWalletConnectListeners();
    if (accounts[0]) {
      stateEventObserver.emit(EventTypes.DISCONNECT, null);
      stateEventObserver.emit(EventTypes.CONNECT_REQUEST_COMPONENT, { networkId, rpcUrl, connectionType: WALLET_TYPES.walletConnect });
    } else {
      stateEventObserver.emit(EventTypes.DISCONNECT, null);
    }
  });

  // Subscribe to chainId change
  provider.on('chainChanged', () => {
    removeWalletConnectListeners();
    stateEventObserver.emit(EventTypes.DISCONNECT, null);
    if (!document.hidden) {
      stateEventObserver.emit(EventTypes.CONNECT_REQUEST_COMPONENT, {
        networkId,
        rpcUrl,
        connectionType: WALLET_TYPES.walletConnect,
      });
    }
  });

  // Subscribe to session disconnection
  // TODO: set types
  provider.on('disconnect', (code: string | number, reason: string) => {
    removeWalletConnectListeners();
    stateEventObserver.emit(EventTypes.DISCONNECT, reason);
  });
};

export const getWalletConnectProvider = async (rpcUrl: string, networkId: number) => {
  // Create WalletConnect Provider
  // https://docs.walletconnect.org/quick-start/dapps/web3-provider#setup
  provider = new WalletConnectProvider({
    rpc: {
      [networkId]: rpcUrl,
    },
  });

  /** Fix for deposit and withdraw promise
   * https://github.com/ChainSafe/web3.js/issues/3891#issuecomment-828722105 */
  // eslint-disable-next-line no-proto
  delete provider.__proto__.request;
  // eslint-disable-next-line no-unused-expressions,no-prototype-builtins
  if (provider.hasOwnProperty('request')) {
    delete provider.request;
  }

  //  Enable session (triggers QR Code modal)
  await provider.enable();
  if (provider.chainId !== networkId) {
    await provider.disconnect();
    throw new Error(`Your wallet network is not the same as in the app. Please, switch to the ${networks[networkId]?.chainName} network`);
  }
  subscribeWalletConnectEvents(networkId, rpcUrl);
  return { provider };
};
